module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-card', {
    staticClass: "bordered-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n        Manange Tutorials\n      ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goto('/admin/settings/tutorials/tutorial-new')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n          Add new\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    ref: "faqTable",
    attrs: {
      "hide-actions": "",
      "headers": _vm.headers,
      "items": _vm.tutorials,
      "rows-per-page-items": [100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          key: props.item.id,
          staticClass: "sortableRow"
        }, [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "0.1%"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1), _vm._v(" "), _c('span', [_vm._v("Click and drag to reorder")])], 1)], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.question))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm._f("ellipseText")(props.item.answer, 120)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs5": "",
            "sm5": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.goto('/admin/settings/tutorials/tutorial-new?mode=edit&id=' + props.item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs5": "",
            "sm5": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.selectedItem = props.item;
              _vm.deleteDialog = true
            }
          }
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)], 1)], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Delete Question")]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this question "), _c('b', [_vm._v(_vm._s(_vm.selectedItem.question))])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteTutorial.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b2a906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Tutorial/TutorialTable.vue
// module id = 1700
// module chunks = 5